import React from "react";
import { useState, useRef } from "react";
import { RiDeleteBin5Line } from "react-icons/ri";
import { FiEdit } from "react-icons/fi";
import { MdDragIndicator } from "react-icons/md";
import "../../assets/styles/category.css";
import image1 from "../../assets/images/image1.png";
import Modal from "../../components/common/modal";
import { IoBagAdd } from "react-icons/io5";
import { Reorder } from "framer-motion";

import { useMacroStore } from "../../hooks/macrofamily/macro.store";
import { useViewMacrofamily } from "../../hooks/macrofamily/macro.showall";
import { useMacroRemove } from "../../hooks/macrofamily/macro.remove";
import { useMacroUpdate } from "../../hooks/macrofamily/macro.update";
import { useViewSingleMacrofamily } from "../../hooks/macrofamily/macro.show";

import { toast } from "react-hot-toast";
import Swal from "sweetalert2";
import "sweetalert2/dist/sweetalert2.min.css";




const MacroFamilyList = () => {

  const [macrofamilyData, setMacrofamilyData] = useState([]);
  const [storeLoader, setStoreLoader] = useState(false);
  const prevOrderRef = useRef([]);
  const [imageBlobUrls, setImageBlobUrls] = useState({});
  const [error, setError] = useState("");


  const [isModalOpen, setIsModalOpen] = useState(false);
  const [formData, setFormData] = useState({
    title: "",
    image: null,
    slug: "",
    description: "",
    color: "#004996",
    catlogs: [],
  });

  const [editFormData, setEditFormData] = useState({
    title: "",
    slug: "",
    description: "",
    color: "#004996",
    catlogs: [],
    image: null,
  });
  const [editingFamily, setEditingFamily] = useState(null);

  const [existingImage, setExistingImage] = useState(null);
  const [existingCatalog, setExistingCatalog] = useState([]);
  const [existingImageBlob, setExistingImageBlob] = useState(null);
  const [imagePreview, setImagePreview] = useState();



  const { data, isLoading, isError, } = useViewMacrofamily();


  React.useEffect(() => {
    if (data && data.data && Array.isArray(data.data.macros)) {
      const mappedData = data.data.macros.map((item) => ({
        id: item._id,
        image: item.image,
        title: item.title,
        color: item.color || "#004996",
        catlogs: item.catlogs,
        order: item.order || 0,
      }));
      
      const sortedData = mappedData.sort((a, b) => {
        if (a.order === 0 && b.order === 0) return 0;
        if (a.order === 0) return 1;  
        if (b.order === 0) return -1; 
        return a.order - b.order; 
      });
      
      setMacrofamilyData(sortedData);
      prevOrderRef.current = sortedData.map((item) => item.id);
    }
  }, [data]);

  React.useEffect(() => {
    let isMounted = true;

    const loadImages = async () => {
      const newBlobUrls = {};
      for (const macro of macrofamilyData) {
        if (macro.image) {
         const imageUrl = `${process.env.REACT_APP_BASE_IMAGE.replace(/\/$/, '')}/${macro.image.replace(/^\/+/, '')}`;
          try {
            const response = await fetch(imageUrl);
            if (response.ok) {
              const blob = await response.blob();
              newBlobUrls[macro.id] = URL.createObjectURL(blob);
            }
          } catch (err) {
            console.error('Error loading image:', err);
          }
        }
      }
      if (isMounted) {
        setImageBlobUrls(newBlobUrls);
      }
    };

    if (macrofamilyData.length > 0) {
      loadImages();
    }

    console.log("iamge blog urls", imageBlobUrls);

    return () => {
      isMounted = false;
      // Cleanup blob URLs
      Object.values(imageBlobUrls).forEach(url => URL.revokeObjectURL(url));
    };
  }, [macrofamilyData]);

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData({ ...formData, [name]: name === "slug" ? value.toLowerCase() : value });
    if (name === "slug" && error) {
      setError("");
    }
  };

  const handleImageChange = (e) => {
    const file = e.target.files[0];
    if (file) {
      setFormData((prev) => ({ ...prev, image: file }));
      const reader = new FileReader();
      reader.onload = function (ev) {
        setImagePreview(ev.target.result);
      };
      reader.readAsDataURL(file);
    }
  };

  const handleRemoveImage = () => {
    setFormData((prev) => ({ ...prev, image: null }));
    setImagePreview(undefined);
  };

  const handlecatlogsChange = (e) => {
    const files = Array.from(e.target.files);
    const validFiles = files.filter(file => file.type === "application/pdf");
    
    if (validFiles.length > 0) {
      setFormData((prev) => ({ ...prev, catlogs: [...prev.catlogs, ...validFiles] }));
      toast.success(`${validFiles.length} catlog(s) added`);
    } else {
      toast.error("Please select valid PDF files for catlogs.");
    }
  };

  const handleRemoveCatalog = (index) => {
    setFormData((prev) => ({
      ...prev,
      catlogs: prev.catlogs.filter((_, i) => i !== index)
    }));
    toast.success("Catlog removed");
  };

  const handleRemoveExistingCatalog = (index) => {
    setExistingCatalog((prev) => prev.filter((_, i) => i !== index));
    toast.success("Catalog removed");
  };

  const handleOpenModal = () => {
    setIsModalOpen(true);
    setEditingFamily(null);
    setEditMacroId(null);
    setFormData({ title: "", slug: "", description: "", color: "#004996", image: null, catlogs: [] });
    setImagePreview(undefined);
    setExistingImage(null);
    setExistingImageBlob(null);
    setExistingCatalog([]);
  };

  const handleCloseModal = () => {
    setIsModalOpen(false);
    setEditingFamily(null);
    setEditMacroId(null);
    setFormData({ title: "", slug: "", description: "", color: "#004996", image: null, catlogs: [] });
    setImagePreview(undefined);
    setExistingImage(null);
    setExistingImageBlob(null);
    setExistingCatalog([]);
  };

  const macroStoreMutation = useMacroStore();
  const macroRemoveMutation = useMacroRemove();
  const macroUpdateMutation = useMacroUpdate();
  const [editMacroId, setEditMacroId] = useState(null);
  const macrosingleViewMutation = useViewSingleMacrofamily(editMacroId);



  const handleDelete = async (macroId) => {
    if (!macroId) return;
    try {
      const result = await Swal.fire({
        title: "Delete Macro Family?",
        text:"Are you sure you want to delete this macro family?",
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#d33",
        cancelButtonColor: "#3085d6",
        confirmButtonText: "Yes, delete it!",
        cancelButtonText: "No, cancel",
      });

      if (result.isConfirmed) {
        const response = await macroRemoveMutation.mutateAsync(macroId);
        if (response?.success) {
          await Swal.fire("Macro family deleted!", "Your macro family has been deleted.", "success");
          setMacrofamilyData((prev) =>
            prev.filter((item) => item.id !== macroId)
          );
        } else {
          await Swal.fire("Failed to delete macro family.", "There was an error deleting the macro family.", "error");
        }
      }

  
    } catch (err) {
      Swal.fire("Error", "There was an error deleting the macro family.", "error");
    }
  };

  const slugRegex = /^[a-z0-9-]+$/;

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (storeLoader) return;

    try {
      const trimmedTitle = formData.title?.trim();
      const trimmedSlug = formData.slug?.trim().toLowerCase();
      const trimmedDescription = formData.description?.trim();

      if (!trimmedTitle || !trimmedSlug || !trimmedDescription) {
        toast.error("Title, slug, and description are required fields");
        return;
      }

      if (!slugRegex.test(trimmedSlug)) {
        setError("Slug must contain only lowercase letters, numbers, and hyphens.");
        toast.error("Slug must be lowercase and contain only letters, numbers, and hyphens");
        return;
      }


      if (!editingFamily && !formData.image) {
        toast.error("Image is required when creating a new macro family");
        return;
      }

      const data = new FormData();
      data.append("title", trimmedTitle);
      data.append("slug", trimmedSlug);
      data.append("description", trimmedDescription);
      data.append("color", formData.color || "");
      if (formData.image) data.append("image", formData.image);
      
      formData.catlogs.forEach((catlog) => {
        data.append("catlogs", catlog);
      });
      
      if (editingFamily && existingCatalog.length > 0) {
        data.append("existingCatlogs", JSON.stringify(existingCatalog));
      }

      setStoreLoader(true);

      let response;
      if (editingFamily) {
        
        response = await macroUpdateMutation.mutateAsync({
            id: editingFamily,
            body: data,
          });

        if (response?.success && response?.data) {
          toast.success("Macro family updated successfully!");
          setStoreLoader(false);
          handleCloseModal();
        } else {
          toast.error("Failed to update macro family.");
          setStoreLoader(false);
        }
      } else {
        response = await macroStoreMutation.mutateAsync(data);
        if (response?.success && response?.data) {
          toast.success("Macro family created successfully!");
          if (response.data.macros && Array.isArray(response.data.macros)) {
            setStoreLoader(false);
          } else {
            setMacrofamilyData((prev) => [
              ...prev,
              {
                id: response.data._id,
                image: response.data.image,
                title: response.data.title,
                color: response.data.color || formData.color || "#004996",
                catlogs: response.data.catlogs && response.data.catlogs.length > 0 ? response.data.catlogs[0] : null,
              },
            ]);
            setStoreLoader(false);
          }
          handleCloseModal();
        } else if (response?.errors && Array.isArray(response.errors)) {
          const imageError = response.errors.find(e => e.path === 'image');
          if (imageError) {
            toast.error(imageError.msg || 'Image upload error');
          } else {
            toast.error("Failed to create macro family.");
          }
        } else {
          toast.error("Failed to create macro family.");
        }
      }
    } catch (err) {
      toast.error(editingFamily ? "Error updating macro family." : "Error creating macro family.");
    } finally {
      setStoreLoader(false);
    }
  };

  const handleEdit = (macroid) => {
    setIsModalOpen(true);
    setEditMacroId(macroid);
    setEditingFamily(macroid);
  };

  React.useEffect(() => {
    let isMounted = true;

    const loadExistingData = async () => {
      if (macrosingleViewMutation?.data?.data) {
        const macro = macrosingleViewMutation.data.data;

        setFormData({
          title: macro.title || "",
          slug: macro.slug || "",
          description: macro.description || "",
          color: macro.color || "#004996",
          image: null,
          catlogs: [],
        });

        setExistingImage(macro.image || null);
        setExistingCatalog(Array.isArray(macro.catlogs) ? macro.catlogs : (macro.catlogs ? [macro.catlogs] : []));

        if (macro.image) {
          try {
            const imageUrl = `${process.env.REACT_APP_BASE_IMAGE}${macro.image}`;
            const response = await fetch(imageUrl, {
            });

            if (response.ok && isMounted) {
              const blob = await response.blob();
              const blobUrl = URL.createObjectURL(blob);
              setExistingImageBlob(blobUrl);
              setImagePreview(blobUrl);
            }
          } catch (err) {
            console.error('Error loading existing image:', err);
          }
        }
      }
    };

    loadExistingData();

    return () => {
      isMounted = false;
    };
  }, [macrosingleViewMutation.data]);



  const CategoryItem = ({ category }) => {
    const displayImage = imageBlobUrls[category.id] || image1;
    
    return (
      <div className="category-item">
        <span
          style={{
            cursor: "grab",
            marginRight: 12,
            display: "flex",
            alignItems: "center",
          }}
        >
          <MdDragIndicator size={22} color="#898989" />
        </span>
        <span className="category-content">
          {category.image && (
            <img
              src={displayImage}
              alt={category.title}
              className="macrofamily-image"
              style={{ width: 60, height: 60, objectFit: "cover", borderRadius: 8 }}
              onError={(e) => {
                e.target.onerror = null;
                e.target.src = image1;
              }}
            />
          )}
          <div
            style={{
              display: "flex",
              flexDirection: "column",
              flex: 1,
              minWidth: 0,
              marginRight: "10px",
            }}
          >
            <span className="category-names">{category.title}</span>
            {category.color ? (
              <span style={{ display: "inline-flex", alignItems: "center", gap: "6px", marginTop: "4px", fontSize: "12px", color: "#666" }}>
                <span style={{ width: "12px", height: "12px", borderRadius: "50%", backgroundColor: category.color, border: "1px solid #ddd" }} />
                {category.color}
              </span>
            ) : null}
          </div>
          <div className="commonBtn">
            <div className="both">
              <button
                onPointerDown={(e) => e.stopPropagation()}
                onClick={(e) => {
                  e.stopPropagation();
                  handleDelete(category.id);
                }}
                aria-label="Delete"
              >
                <RiDeleteBin5Line
                  style={{ color: "#c20e0eff", width: "20px", height: "20px" }}
                />
              </button>
              <button
                onPointerDown={(e) => e.stopPropagation()}
                onClick={(e) => {
                  e.stopPropagation();
                  handleEdit(category.id);
                }}
                aria-label="Edit"
              >
                <FiEdit
                  style={{ color: "#9d9d9d", width: "20px", height: "20px" }}
                />
              </button>
            </div>
          </div>
        </span>
      </div>
    );
  };

  const updateOrder = async (id, order) => {
    try {
      const response = await macroUpdateMutation.mutateAsync({ id, body: { order } });
      if (response?.success) {
        console.log(`Order updated to ${order} for id ${id}`);
      } else {
        toast.error("Failed to update order");
      }
    } catch (err) {
      console.error("Error updating order:", err);
      toast.error("Failed to update order");
    }
  };

  const handleReorder = async (newOrder) => {
    setMacrofamilyData(newOrder);

    const prevIds = prevOrderRef.current;
    const prevIndexMap = new Map(prevIds.map((id, idx) => [id, idx]));
    const newIds = newOrder.map((item) => item.id);

    prevOrderRef.current = newIds;

    const updates = [];
    newIds.forEach((id, idx) => {
      const oldIdx = prevIndexMap.get(id);
      if (oldIdx !== undefined && oldIdx !== idx) {
        updates.push({ id, order: idx + 1 });
      }
    });

    if (updates.length > 0) {
      try {
        await Promise.all(
          updates.map(({ id, order }) => updateOrder(id, order))
        );
        toast.success("Order updated successfully");
      } catch (err) {
        console.error("Error updating orders:", err);
        toast.error("Failed to update order");
      }
    }
  };


  if(isLoading){
    return <div>Loading...</div>;
  }

  if(isError){
    return <div>Error loading macro families.</div>;
  }

  return (
    <>
      <button
        className="commonButton"
        onClick={handleOpenModal}
        style={{ marginLeft: "auto" }}
      >
        <IoBagAdd size={20} color="#ffffff" style={{ marginRight: 8 }} /> Add
        Macro Family
      </button>

      <Modal
        isOpen={isModalOpen}
        onClose={handleCloseModal}
        title={editingFamily ? "Edit Macro Family" : "Add New Macro Family"}  
      >
              <div className="body"
              style={{
          overflowY: "auto",
          paddingTop: "64px",
          paddingLeft: "10px",
          paddingRight: "10px",
        }} >
          <form onSubmit={handleSubmit}>
            <div className="category-modal">
              <label
                htmlFor="title"
                style={{
                  display: "block",
                  marginBottom: "8px",
                  textAlign: "left",
                }}
              >
                Title
              </label>
              <input
                type="text"
                id="title"
                name="title"
                value={formData.title}
                onChange={handleInputChange}
              />
            </div>

            <div>
              <label
                htmlFor="slug"
                style={{
                  display: "block",
                  marginBottom: "8px",
                  textAlign: "left",
                }}
              >
                Slug
              </label>
              <input
                type="text"
                id="slug"
                name="slug"
                value={formData.slug}
                onChange={handleInputChange}
              />
              {error ? (
                <span style={{ fontSize: "11px", color: "#d32f2f" }}>{error}</span>
              ) : null}
            </div>

            <div>
              <label
                htmlFor="description"
                style={{
                  display: "block",
                  marginBottom: "8px",
                  textAlign: "left",
                }}
              >
                Description
              </label>
              <textarea
                id="description"
                name="description"
                value={formData.description}
                onChange={handleInputChange}
              />
            </div>

            <div>
              <label
                htmlFor="color"
                style={{
                  display: "block",
                  marginBottom: "8px",
                  textAlign: "left",
                }}
              >
                Color
              </label>
              <div style={{ display: "flex", alignItems: "center", gap: "10px" }}>
                <input
                  type="color"
                  id="color"
                  name="color"
                  value={formData.color || "#004996"}
                  onChange={handleInputChange}
                  style={{ width: "44px", height: "36px", padding: 0, border: "none", background: "transparent", cursor: "pointer" }}
                />
                <input
                  type="text"
                  name="color"
                  value={formData.color || "#004996"}
                  onChange={handleInputChange}
                  placeholder="#004996"
                  style={{ flex: 1 }}
                />
              </div>
            </div>

            <div
              className="form-headerr"
              
            >
              <div className="image-upload-section" style={{ flex: 1 }}>
                <label 
                  htmlFor="imageUpload"
                  style={{
                    display: "block",
                    marginBottom: "12px",
                    fontWeight: "600",
                    fontSize: "14px",
                    color: "#333",
                  }}
                >
                   Upload Image
                </label>
                <div 
                  style={{
                    position: "relative",
                    width: "100%",
                    aspectRatio: "1",
                    maxWidth: "200px",
                    border: (formData.image || existingImageBlob)
                      ? "2px solid #4CAF50"
                      : "2px dashed #ccc",
                    borderRadius: "12px",
                    overflow: "hidden",
                    background: (formData.image || existingImageBlob)
                      ? `url(${imagePreview}) center/cover no-repeat`
                      : "#f8f9fa",
                    transition: "all 0.3s ease",
                    cursor: "pointer",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    boxShadow: (formData.image || existingImageBlob)
                      ? "0 4px 12px rgba(76, 175, 80, 0.2)"
                      : "0 2px 8px rgba(0,0,0,0.08)",
                  }}
                  onMouseEnter={(e) => {
                    if (!formData.image && !existingImageBlob) {
                      e.currentTarget.style.borderColor = "#4CAF50";
                      e.currentTarget.style.background = "#f0f8f0";
                    }
                  }}
                  onMouseLeave={(e) => {
                    if (!formData.image && !existingImageBlob) {
                      e.currentTarget.style.borderColor = "#ccc";
                      e.currentTarget.style.background = "#f8f9fa";
                    }
                  }}
                >
                  <input
                    type="file"
                    id="imageUpload"
                    accept=".png, .jpg, .jpeg"
                    onChange={handleImageChange}
                    style={{
                      position: "absolute",
                      width: "100%",
                      height: "100%",
                      opacity: 0,
                      cursor: "pointer",
                      zIndex: 1,
                    }}
                  />
                  
                  {!formData.image && !existingImageBlob && (
                    <div style={{
                      textAlign: "center",
                      padding: "20px",
                      color: "#666",
                    }}>
                      <div style={{ fontSize: "32px", marginBottom: "8px" }}>📷</div>
                      <div style={{ fontSize: "13px", fontWeight: "500" }}>Click to upload</div>
                      <div style={{ fontSize: "11px", color: "#999", marginTop: "4px" }}>PNG, JPG, JPEG</div>
                    </div>
                  )}

                  {(formData.image || existingImageBlob) && (
                    <>
                      <div
                        style={{
                          position: "absolute",
                          top: 0,
                          left: 0,
                          right: 0,
                          bottom: 0,
                          background: "rgba(0,0,0,0)",
                          display: "flex",
                          alignItems: "center",
                          justifyContent: "center",
                          opacity: 0,
                          transition: "opacity 0.3s ease",
                        }}
                        onMouseEnter={(e) => e.currentTarget.style.opacity = 1}
                        onMouseLeave={(e) => e.currentTarget.style.opacity = 0}
                      >
                        <div style={{
                          background: "rgba(0,0,0,0.7)",
                          color: "white",
                          padding: "8px 12px",
                          borderRadius: "6px",
                          fontSize: "12px",
                          fontWeight: "500",
                        }}>
                          Click to change
                        </div>
                      </div>
                      <button
                        type="button"
                        onClick={(e) => {
                          e.stopPropagation();
                          handleRemoveImage();
                          setExistingImage(null);
                          setExistingImageBlob(null);
                          toast.success("Image removed");
                        }}
                        title="Remove image"
                        style={{
                          position: "absolute",
                          top: 8,
                          right: 8,
                          background: "#fff",
                          borderRadius: "50%",
                          border: "none",
                          cursor: "pointer",
                          padding: 8,
                          boxShadow: "0 2px 8px rgba(0,0,0,0.25)",
                          zIndex: 2,
                          display: "flex",
                          alignItems: "center",
                          justifyContent: "center",
                          transition: "all 0.2s ease",
                        }}
                        onMouseEnter={(e) => {
                          e.currentTarget.style.transform = "scale(1.1)";
                          e.currentTarget.style.background = "#fee";
                        }}
                        onMouseLeave={(e) => {
                          e.currentTarget.style.transform = "scale(1)";
                          e.currentTarget.style.background = "#fff";
                        }}
                      >
                        <RiDeleteBin5Line size={18} color="#c20e0e" />
                      </button>
                    </>
                  )}
                </div>
              </div>
              <div className="image-upload-section" style={{ flex: 1 }}>
                <div style={{ display: "flex", alignItems: "center", justifyContent: "space-between", marginBottom: "12px" }}>
                  <label 
                    htmlFor="catlogsUpload"
                    style={{
                      fontWeight: "600",
                      fontSize: "14px",
                      color: "#333",
                    }}
                  >
                     Upload Catlogs (PDF)
                  </label>
                  {(formData.catlogs.length > 0 || existingCatalog.length > 0) && (
                    <span style={{
                      background: "#667eea",
                      color: "white",
                      padding: "4px 10px",
                      borderRadius: "12px",
                      fontSize: "11px",
                      fontWeight: "600",
                    }}>
                      {formData.catlogs.length + existingCatalog.length} file{(formData.catlogs.length + existingCatalog.length) !== 1 ? 's' : ''}
                    </span>
                  )}
                </div>
                
                {/* Upload Button */}
                <div style={{ marginBottom: "12px" }}>
                  <input
                    type="file"
                    id="catlogsUpload"
                    accept="application/pdf"
                    multiple
                    onChange={handlecatlogsChange}
                    style={{
                      display: "none",
                    }}
                  />
                  <label
                    htmlFor="catlogsUpload"
                    style={{
                      padding: "12px 16px",
                      background: "linear-gradient(135deg, #667eea 0%, #764ba2 100%)",
                      color: "white",
                      borderRadius: "8px",
                      textAlign: "center",
                      cursor: "pointer",
                      fontWeight: "500",
                      fontSize: "13px",
                      boxShadow: "0 4px 12px rgba(102, 126, 234, 0.3)",
                      transition: "all 0.3s ease",
                      border: "none",
                      display: "block",
                    }}
                    onMouseEnter={(e) => {
                      e.currentTarget.style.transform = "translateY(-2px)";
                      e.currentTarget.style.boxShadow = "0 6px 16px rgba(102, 126, 234, 0.4)";
                    }}
                    onMouseLeave={(e) => {
                      e.currentTarget.style.transform = "translateY(0)";
                      e.currentTarget.style.boxShadow = "0 4px 12px rgba(102, 126, 234, 0.3)";
                    }}
                  >
                    ➕ Choose PDF Files
                  </label>
                </div>

                {/* Catlogs List */}
                <div
                  style={{
                    display: "flex",
                    flexDirection: "column",
                    gap: "10px",
                    minHeight: 100,
                    maxHeight: 300,
                    overflowY: "auto",
                    padding: "12px",
                    background: "#f8f9fa",
                    borderRadius: "10px",
                    border: "2px solid #e9ecef",
                  }}
                >
                  {/* Existing catalogs from server */}
                  {existingCatalog.length > 0 && (
                    <div>
                      <div style={{
                        fontSize: "11px",
                        color: "#666",
                        marginBottom: "8px",
                        fontWeight: "600",
                        textTransform: "uppercase",
                        letterSpacing: "0.5px",
                      }}>
                        📌 Saved Catlogs
                      </div>
                      {existingCatalog.map((catalog, index) => (
                        <div
                          key={`existing-${index}`}
                          style={{
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "space-between",
                            padding: "10px 12px",
                            background: "linear-gradient(135deg, #e0f2fe 0%, #dbeafe 100%)",
                            borderRadius: "8px",
                            border: "1px solid #93c5fd",
                            marginBottom: "8px",
                            transition: "all 0.2s ease",
                            boxShadow: "0 2px 4px rgba(59, 130, 246, 0.1)",
                          }}
                          onMouseEnter={(e) => {
                            e.currentTarget.style.transform = "translateX(4px)";
                            e.currentTarget.style.boxShadow = "0 4px 8px rgba(59, 130, 246, 0.2)";
                          }}
                          onMouseLeave={(e) => {
                            e.currentTarget.style.transform = "translateX(0)";
                            e.currentTarget.style.boxShadow = "0 2px 4px rgba(59, 130, 246, 0.1)";
                          }}
                        >
                          <div style={{ display: "flex", alignItems: "center", flex: 1, minWidth: 0 }}>
                            <span style={{ fontSize: "20px", marginRight: "10px" }}>📄</span>
                            <span
                              style={{
                                overflow: "hidden",
                                textOverflow: "ellipsis",
                                whiteSpace: "nowrap",
                                fontSize: "13px",
                                color: "#1e40af",
                                fontWeight: "500",
                              }}
                              title={catalog}
                            >
                              {catalog.split('/').pop() || catalog}
                            </span>
                          </div>
                          <button
                            type="button"
                            onClick={() => handleRemoveExistingCatalog(index)}
                            title="Remove catlog"
                            style={{
                              background: "#fff",
                              border: "1px solid #fecaca",
                              borderRadius: "6px",
                              cursor: "pointer",
                              padding: "6px",
                              display: "flex",
                              alignItems: "center",
                              marginLeft: "8px",
                              transition: "all 0.2s ease",
                            }}
                            onMouseEnter={(e) => {
                              e.currentTarget.style.background = "#fee2e2";
                              e.currentTarget.style.transform = "scale(1.1)";
                            }}
                            onMouseLeave={(e) => {
                              e.currentTarget.style.background = "#fff";
                              e.currentTarget.style.transform = "scale(1)";
                            }}
                          >
                            <RiDeleteBin5Line size={16} color="#dc2626" />
                          </button>
                        </div>
                      ))}
                    </div>
                  )}

                  {/* New catlogs to upload */}
                  {formData.catlogs.length > 0 && (
                    <div>
                      <div style={{
                        fontSize: "11px",
                        color: "#666",
                        marginBottom: "8px",
                        marginTop: existingCatalog.length > 0 ? "12px" : "0",
                        fontWeight: "600",
                        textTransform: "uppercase",
                        letterSpacing: "0.5px",
                      }}>
                        🆕 New Catlogs
                      </div>
                      {formData.catlogs.map((catlog, index) => (
                        <div
                          key={`new-${index}`}
                          style={{
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "space-between",
                            padding: "10px 12px",
                            background: "linear-gradient(135deg, #d1fae5 0%, #a7f3d0 100%)",
                            borderRadius: "8px",
                            border: "1px solid #6ee7b7",
                            marginBottom: "8px",
                            transition: "all 0.2s ease",
                            boxShadow: "0 2px 4px rgba(16, 185, 129, 0.1)",
                          }}
                          onMouseEnter={(e) => {
                            e.currentTarget.style.transform = "translateX(4px)";
                            e.currentTarget.style.boxShadow = "0 4px 8px rgba(16, 185, 129, 0.2)";
                          }}
                          onMouseLeave={(e) => {
                            e.currentTarget.style.transform = "translateX(0)";
                            e.currentTarget.style.boxShadow = "0 2px 4px rgba(16, 185, 129, 0.1)";
                          }}
                        >
                          <div style={{ display: "flex", alignItems: "center", flex: 1, minWidth: 0 }}>
                            <span style={{ fontSize: "20px", marginRight: "10px" }}>📄</span>
                            <span
                              style={{
                                overflow: "hidden",
                                textOverflow: "ellipsis",
                                whiteSpace: "nowrap",
                                fontSize: "13px",
                                color: "#047857",
                                fontWeight: "500",
                              }}
                              title={catlog.name}
                            >
                              {catlog.name}
                            </span>
                          </div>
                          <button
                            type="button"
                            onClick={() => handleRemoveCatalog(index)}
                            title="Remove catlog"
                            style={{
                              background: "#fff",
                              border: "1px solid #fecaca",
                              borderRadius: "6px",
                              cursor: "pointer",
                              padding: "6px",
                              display: "flex",
                              alignItems: "center",
                              marginLeft: "8px",
                              transition: "all 0.2s ease",
                            }}
                            onMouseEnter={(e) => {
                              e.currentTarget.style.background = "#fee2e2";
                              e.currentTarget.style.transform = "scale(1.1)";
                            }}
                            onMouseLeave={(e) => {
                              e.currentTarget.style.background = "#fff";
                              e.currentTarget.style.transform = "scale(1)";
                            }}
                          >
                            <RiDeleteBin5Line size={16} color="#dc2626" />
                          </button>
                        </div>
                      ))}
                    </div>
                  )}

                  {formData.catlogs.length === 0 && existingCatalog.length === 0 && (
                    <div style={{
                      textAlign: "center",
                      padding: "32px 16px",
                      color: "#9ca3af",
                    }}>
                      <div style={{ fontSize: "40px", marginBottom: "8px" }}>📂</div>
                      <div style={{ fontSize: "13px", fontWeight: "500" }}>No catlogs uploaded</div>
                      <div style={{ fontSize: "11px", marginTop: "4px" }}>Click the button above to add PDF files</div>
                    </div>
                  )}
                </div>
              </div>
            </div>

            <div className="form-button-group">
              <button
                type="button"
                onClick={handleCloseModal}
                className="cancelBtn"
                disabled={storeLoader}
              >
                Cancel
              </button>
              <button
                type="submit"
                className="commonButton"
                disabled={storeLoader}
                style={{ opacity: storeLoader ? 0.7 : 1, cursor: storeLoader ? "not-allowed" : "pointer" }}
              >
                {storeLoader ? "Saving..." : editingFamily ? "Update" : "Save"}
              </button>
            </div>
          </form>
          </div>
          </Modal>


      <div className="categories-container">
        <Reorder.Group
          axis="y"
          values={macrofamilyData}
          onReorder={handleReorder}
          style={{ listStyleType: "none", paddingLeft: 0 }}
        >
          {macrofamilyData.map((item) => (
            <Reorder.Item key={item.id} value={item}>
              <CategoryItem category={item} />
            </Reorder.Item>
          ))}
        </Reorder.Group>
      </div>
    </>
  );
};

export default MacroFamilyList;
